module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-container",
    on: {
      "mouseenter": _vm.pause,
      "mouseleave": _vm.play
    }
  }, [_c('div', {
    staticClass: "carousel-track",
    style: ({
      transform: ("translateX(-" + (_vm.currentIndex * 100) + "%)")
    })
  }, [_c('img', {
    staticClass: "carousel-item",
    attrs: {
      "src": _vm.images[_vm.images.length - 1],
      "alt": "carousel-img"
    },
    on: {
      "error": _vm.handleImgError
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(image, index) {
    return _c('img', {
      key: index,
      staticClass: "carousel-item",
      attrs: {
        "src": image,
        "alt": "carousel-img"
      },
      on: {
        "error": _vm.handleImgError
      }
    })
  }), _vm._v(" "), _c('img', {
    staticClass: "carousel-item",
    attrs: {
      "src": _vm.images[0],
      "alt": "carousel-img"
    },
    on: {
      "error": _vm.handleImgError
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4baf1c81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carousel.vue
// module id = 977
// module chunks = 1